import { BasePlugin } from 'Core/PluginCore/BasePlugin'
import { PluginConnector } from 'Core/PluginCore/PluginConnector'
import { PluginConfigType } from 'Core/PluginCore/PluginsManager'
import { Studio } from 'Core/Studio'

export type MathTypePluginConfigType = {
    /**
     *
     */
}

export class MathTypePlugin extends BasePlugin {
    public readonly id = 'Math Type'

    constructor(
        config: PluginConfigType<MathTypePluginConfigType>,
        pluginConnectors: PluginConnector[]
    ) {
        super(config, pluginConnectors)
    }

    public initialize(studio: Studio) {
        this.studio = studio
    }
}
